function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-kanra-2x-secret-a",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD199",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA953",
  offset: "59.758%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAB239",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "avatar-kanra-2x-secret-b",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("path", {
  id: "avatar-kanra-2x-secret-c",
  d: "M59.117 44.99c0 .646-.523 1.17-1.168 1.17H36.96c-.645 0-1.168-.524-1.168-1.17v-9.113c0-.645.523-1.168 1.168-1.168h20.99c.644 0 1.167.52 1.167 1.166v9.114zm-35.21-19.234c.644 0 1.167-.523 1.167-1.168v-7.322c0-.645.524-1.17 1.17-1.17h8.38c.646 0 1.17.525 1.17 1.17v7.322c0 .645.523 1.168 1.168 1.168H57.95c.644 0 1.167-.523 1.167-1.168v-7.322c0-.645.523-1.17 1.168-1.17h8.382c.646 0 1.17.525 1.17 1.17v7.322c0 .645.523 1.168 1.168 1.168h15.853c.907 0 1.642-.735 1.642-1.642C88.5 14.387 80.614 6.5 70.886 6.5H24.114C14.386 6.5 6.5 14.387 6.5 24.114c0 .907.735 1.642 1.642 1.642h15.764zm34.042 29.33H36.96c-.645 0-1.168.524-1.168 1.17v12.11c0 .644.523 1.167 1.168 1.167h20.99c.644 0 1.167-.523 1.167-1.168v-12.11c0-.645-.523-1.168-1.168-1.168zM71.003 34.71c-.645 0-1.17.522-1.17 1.167V70.72c0 5.026-4.075 9.104-9.104 9.104H27.85c-1.533 0-2.776-1.243-2.776-2.775V35.875c0-.645-.523-1.168-1.168-1.168H8.142c-.907 0-1.642.734-1.642 1.64v34.536c0 9.727 7.886 17.614 17.614 17.614h46.772c9.728 0 17.614-7.887 17.614-17.614V36.35c0-.906-.735-1.64-1.642-1.64H71.005z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#avatar-kanra-2x-secret-a)",
  xlinkHref: "#avatar-kanra-2x-secret-b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#avatar-kanra-2x-secret-c"
}));

var SvgKanra = function SvgKanra(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKanra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kanra.ad2a1bcd.svg";
export { ForwardRef as ReactComponent };